import React from 'react';
import DriversEmergency from '@loggi/drivers-emergency';
import { useHistory } from 'react-router-dom';

export default function EmergencyWrapper() {
  const history = useHistory();
  return (
    <DriversEmergency
      goBack={() => {
        history.goBack();
      }}
    />
  );
}
